import {Directive} from "@angular/core";
import {ToastrService} from "ngx-toastr";
import {TranslateService} from "@ngx-translate/core";
import {BaseError} from "./base-error";

@Directive()
export class TranslatedBaseError extends BaseError {
    public successes = [];

    public translateService2: TranslateService;

    constructor(public toastr: ToastrService, public translateService: TranslateService) {
        super(toastr);
    }

    public responseSuccessful(message: any) {
        // debounce messages if too many messages were sent with the same arguments with too small period
        const self = this;
        if (self.successes.indexOf(message) !== -1) {
            return;
        }
        self.successes.push(message);
        setTimeout(() => {
            self.successes.splice(message);
        }, 500);
        self.toastr.toastrConfig.closeButton = false;
        self.toastr.toastrConfig.timeOut = 5000;
        self.toastr.toastrConfig.extendedTimeOut = 5000;
        self.toastr.toastrConfig.tapToDismiss = true;
        self.toastr.toastrConfig.progressBar = true;
        self.toastr.toastrConfig.progressAnimation = "increasing";
        self.toastr.success(this.translate(message));
    }

    public simpleErrorMessage(message: any) {
        // debounce messages if too many messages were sent with the same arguments with too small period
        const self = this;
        if (self.successes.indexOf(message) !== -1) {
            return;
        }
        self.successes.push(message);
        setTimeout(() => {
            self.successes.splice(message);
        }, 500);
        self.toastr.toastrConfig.closeButton = true;
        self.toastr.toastrConfig.timeOut = null;
        self.toastr.toastrConfig.tapToDismiss = true;
        self.toastr.toastrConfig.progressBar = false;
        self.toastr.error(this.translate(message));
    }

    public showErrorMessageWithTitle(title: string, res: any) {
        if (res.status === 401) {
            // Do not reload if already on login page (concurrency issues between auth.guard and wrapper.ts)
            if (!window.location.href.includes("login")) {
                window.location.assign("/login");
            }
        } else if (res.status === 502 || res.status === 503 || res.status === 504 || res.status === 0) {
            this.error("Backend service temporarily unavailable. Please try again.", "Error");
        } else if (this.isEntityNotFound(res)) {
            // Suppress the toast: callers are expected to render an inline empty-state
            // (see <app-entity-not-found>). Returning early avoids the sticky raw-message toast.
            return;
        } else {
            const parsedResponse = res._body ? JSON.parse(res._body) : res;
            const message = this.getMessage(parsedResponse);
            if (message !== "") {
                this.error(message, title);
            }
            if (parsedResponse.errors) {
                for (const err of parsedResponse.errors) {
                    if (err.defaultMessage) {
                        title = "Validation error with " + err.objectName + " " + err.field;
                        this.error(err.defaultMessage, title);
                    } else {
                        this.error(err, title);
                    }
                }
            }
        }
    }

    public error(message: string, title: string) {
        this.toastr.toastrConfig.closeButton = true;
        this.toastr.toastrConfig.timeOut = 10000;
        this.toastr.toastrConfig.extendedTimeOut = 5000;
        this.toastr.toastrConfig.tapToDismiss = true;
        this.toastr.error(this.translate(message), this.translate(title), {enableHtml: true });
    }

    public showErrorMessage(error: any) {
        console.log(error);
        this.showErrorMessageWithTitle(this.translate("Error"), error);
    }

    public showWarningMessage(message: string) {
        this.toastr.toastrConfig.closeButton = true;
        this.toastr.toastrConfig.timeOut = 5000;
        this.toastr.toastrConfig.extendedTimeOut = 5000;
        this.toastr.toastrConfig.tapToDismiss = true;
        this.toastr.toastrConfig.progressBar = true;
        this.toastr.warning(this.translate(message));
    }

    public translate(txt: any): string {
        if (txt && typeof txt === "string") {
          return this.translateService.instant(txt);
        } else {
          return txt;
        }
    }
}
